import { render, staticRenderFns } from "./_move_items_to_folder_modal.vue?vue&type=template&id=20002f9c&scoped=true&"
import script from "./_move_items_to_folder_modal.vue?vue&type=script&lang=js&"
export * from "./_move_items_to_folder_modal.vue?vue&type=script&lang=js&"
import style0 from "./_move_items_to_folder_modal.vue?vue&type=style&index=0&id=20002f9c&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20002f9c",
  null
  
)

export default component.exports